import Button from "@elements/Button";

const defaultProps = {
  label: "Create",
  onClick: () => {},
};

export default function ModalSubmitButton(props) {
  const {
    onClick,
    isLoading,
  } = { ...defaultProps, ...props };

  const label = props.label || defaultProps.label;

  return (
    <Button
      type="submit"
      value={label}
      color="emerald"
      onClick={onClick}
      isLoading={isLoading}
      disabled={isLoading}
    />
  );
}
